module.exports = __webpack_public_path__ + "static/img/4.8ea2c76b.png";